<div class="dialog confirm-dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
  <div mat-dialog-title>
    <header l10nTranslate>admin.editExportLimit</header>
  </div>
  <div mat-dialog-content class="confirm-container" [formGroup]="exportLimitsFormGroup">
    <div class="h-mode flex-container" aria-hidden="true">
      <ng-container *ngFor="let entity of entities">
        <div class="item flex-1 item-{{ entity }}" *ngIf="!!this[entity]">
          <div class="item item--label flex-a-center" scope="col">
            {{ 'admin.' + entity | xTranslate | uppercase }}
          </div>

          <div class="item-input">
            <mat-form-field appearance="outline">
              <input
                matInput
                type="number"
                autocomplete="no-autofill"
                [placeholder]="'admin.' + entity | xTranslate"
                [formControlName]="entity"
                required
              />
              <mat-error *ngIf="this[entity].hasError('required')">
                {{ 'admin.' + entity | xTranslate }} {{ 'admin.isRequired' | xTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-flat-button color="primary" [disabled]="!exportLimitsFormGroup.valid" (click)="submitChange()">
      {{ 'admin.add' | xTranslate }}
    </button>
  </div>
</div>
